<template>
  <q-page padding>
    <PageHeader>
      <template #title> Detalhe Transferencia: #{{ numero }}</template>
    </PageHeader>
    <div
      class="row col-12 row-input-container text-weight-bold text-brand-5 q-mt-md q-gutter-sm"
    >
      <div class="col-md col-xs-6">
        <div class="texto-titulo-input">Unidade Origem</div>
        <q-input
          dense
          outlined
          class="texto-titulo-input"
          disable
          v-model="filtros.unidadeOrigem"
          maxlength="10"
        />
      </div>
      <div class="col-md col-xs-5">
        <div class="texto-titulo-input">Unidade Destino</div>
        <q-input
          dense
          outlined
          disable
          class="texto-titulo-input"
          v-model="filtros.unidadeDestino"
          maxlength="10"
        />
      </div>
      <div class="col-md col-xs-6">
        <div class="texto-titulo-input">Data Criação</div>
        <q-input
          dense
          outlined
          disable
          class="texto-titulo-input"
          v-model="filtros.dataCriacao"
          maxlength="10"
        />
      </div>
      <div class="col-md col-xs-5">
        <div class="texto-titulo-input">Usuario Envio</div>
        <q-input
          dense
          outlined
          disable
          class="texto-titulo-input"
          v-model="filtros.envio"
          maxlength="10"
        />
      </div>
      <div class="col-md col-xs-11">
        <div class="texto-titulo-input">Status</div>
        <q-input
          dense
          outlined
          disable
          class="texto-titulo-input"
          v-model="filtros.status"
          maxlength="10"
        />
      </div>
    </div>
    <div
      class="row col-12 row-input-container text-weight-bold text-brand-5 q-mt-sm q-gutter-sm"
    >
      <div class="col-md col-xs-6">
        <div class="texto-titulo-input">Criador</div>
        <q-input
          dense
          outlined
          disable
          class="texto-titulo-input"
          v-model="filtros.criador"
          maxlength="10"
        />
      </div>
      <div class="col-md col-xs-5">
        <div class="texto-titulo-input">Solicitante</div>
        <q-select
          v-model="filtros.solicitante"
          :options="listaUsuariosSeparador"
          outlined
          disable
          class="texto-titulo-input"
          dense
          label="Selecione o Solicitante"
          use-input
          hide-selected
          fill-input
          option-label="name"
          input-debounce="300"
        />
      </div>
      <div class="col-md col-xs-6">
        <div class="texto-titulo-input">Separador</div>
        <q-select
          v-model="filtros.separador"
          :options="listaUsuariosSeparador"
          outlined
          class="texto-titulo-input"
          disable
          dense
          label="Selecione o Separador"
          @filter="filterSeparador"
          use-input
          hide-selected
          fill-input
          option-label="name"
          input-debounce="300"
        />
      </div>
      <div class="col-md col-xs-5">
        <div class="texto-titulo-input">Usuario Recebimento</div>
        <q-input
          dense
          outlined
          disable
          class="texto-titulo-input"
          v-model="filtros.recebimento"
          maxlength="10"
        />
      </div>
      <div class="col-md col-xs-11">
        <div class="texto-titulo-input">Transportador</div>
        <q-select
          v-model="filtros.transportador"
          :options="listaUsuariosTransportador"
          outlined
          dense
          disable
          class="texto-titulo-input"
          label="Selecione o Transportador"
          @filter="filterTransportador"
          use-input
          hide-selected
          fill-input
          option-label="name"
          input-debounce="300"
        />
      </div>
    </div>

    <div class="q-mt-xl">
      <q-table
        table-header-class="bg-accent text-width-bold"
        :rows="rows"
        :columns="columns"
        :loading="disable"
        dense
        color="primary"
        row-key="id"
        :class="{ 'tabela-tamanho-fixo': !mobile }"
        flat
        :grid="mobile"
        v-model:pagination="pagination"
        no-data-label="Sem dados"
        @request="handleRequest"
        rows-per-page-label="Linhas Por Página"
        :rows-per-page-options="[10, 25, 50, 100]"
      >
        <template v-slot:top>
          <div style="width: 100%" class="flex justify-between">
            <div class="q-ml-md text-brand-5 text-weight-bold titulo-tabela">
              Produtos Selecionados
            </div>
            <div class="flex q-gutter-x-sm">
              <q-btn
                color="primary"
                icon="print"
                label="Imprimir Listagem"
                no-caps
                @click="imprimirPicking"
              />
              <q-btn
                color="secondary"
                icon="print"
                label="Imprimir Listagem Agrupada"
                no-caps
                @click="imprimirPickingAgrupado"
              />
            </div>
          </div>
        </template>
        <template v-slot:item="props">
          <div class="q-pa-xs col-xs-12 col-sm-12 col-md-12">
            <div class="row card">
              <div class="col-12">
                <q-card-section class="row text-brand-5 text-grid-table">
                  <div class="col-12">
                    <span
                      ><strong>Nº Requisição:</strong>
                      {{ props.row.voucherId }}</span
                    >
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Nº Reserva:</strong>
                      {{ props.row?.detalhesProduto?.reserva }}</span
                    >
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Código:</strong>
                      {{ props.row?.detalhesProduto?.codigo }}</span
                    >
                    <span class="q-ml-sm"
                      ><strong>Descrição:</strong>
                      {{ props.row?.detalhesProduto?.nome }}</span
                    >
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Localização:</strong>
                      {{ props.row?.detalhesProduto?.localizacao }}</span
                    >
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Quantidade Solicitada:</strong>
                      {{ props.row?.quantidadeOriginal }}</span
                    >
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Quantidade Separada:</strong>
                      {{ props.row?.quantidadeAtendida }}</span
                    >
                  </div>
                </q-card-section>
              </div>
            </div>
          </div>
        </template>
        <!-- <template #body-cell-disable="props">
          <q-td :props="props">
            <q-input
              dense
              outlined
              label="Digite o Centro"
              v-model="props.row.separada"
              @change="editarQuantidade(props.row)"
              maxlength="10"
            />
          </q-td>
        </template> -->
      </q-table>
    </div>
    <div
      v-if="filtros.status != 'entregue'"
      class="row col-12 container-autenticacao"
    >
      <div class="row col-12 texto-titulo-radio text-brand-5 text-weight-bold">
        Tipo de Requisição
      </div>
      <q-radio
        v-if="
          !$store.state.autenticacao.cliente.includes('staging-vale') &&
          !$store.state.autenticacao.cliente.includes('vale-epiexpress') &&
          $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
            'voucher-auth-assinatura'
          ) != -1
        "
        v-model="tipoAuth"
        label="Assinatura"
        val="assinatura"
        class="texto-titulo-radio text-brand-5 text-weight-bold"
        :size="mobile ? 'md' : 'lg'"
      />
      <q-radio
        v-model="tipoAuth"
        label="Biometria"
        val="biometria"
        class="texto-titulo-radio text-brand-5 text-weight-bold"
        :size="mobile ? 'md' : 'lg'"
        v-if="
          !mobile &&
          $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
            'voucher-auth-biometria'
          ) != -1
        "
      />
      <q-radio
        v-if="
          !$store.state.autenticacao.cliente.includes('staging-acciona') &&
          !$store.state.autenticacao.cliente.includes('acciona') &&
          $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
            'voucher-auth-pin'
          ) != -1
        "
        v-model="tipoAuth"
        label="PIN"
        val="web_pin"
        class="texto-titulo-radio text-brand-5 text-weight-bold"
        :size="mobile ? 'md' : 'lg'"
      />
      <q-radio
        v-if="
          $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
            'voucher-auth-token'
          ) != -1
        "
        v-model="tipoAuth"
        label="Token"
        class="texto-titulo-radio text-brand-5 text-weight-bold"
        val="token"
        :size="mobile ? 'md' : 'lg'"
      />

      <div
        v-if="
          $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
            'voucher-auth-pin'
          ) == -1 &&
          $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
            'voucher-auth-biometria'
          ) == -1 &&
          $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
            'voucher-auth-assinatura'
          ) == -1
        "
        class="q-my-md"
      >
        <span
          >Você não possui nenhum método de autenticação associado ao seu
          usuário, entre em contato com o suporte.</span
        >
      </div>
    </div>
    <div
      class="row col-12 q-mt-lg q-ml-md items-center container-autenticacao-pin"
      v-if="tipoAuth === 'web_pin'"
    >
      <q-icon class="q-mr-xs" name="lock" size="28px" />
      <div class="col-md-2 col-xs-6">
        <q-input v-model="pin" type="password" dense outlined />
      </div>
    </div>
    <div
      v-if="tipoAuth == 'assinatura'"
      class="row col-12 q-mt-md canvas-container"
    >
      <Canvas
        class="col-lg-6 col-md-12 col-xs-12 col-sm-12"
        @update="recebeAssinatura"
        :go="salvarAssinatura"
      />
    </div>
    <!--Passa o id do criado no envio e do solicitante no recebimento-->
    <dialog-confirm
      mensagem="Tem certeza que deseja continuar? "
      :exibir="confirmacao"
      @resultado="enviar"
    >
    </dialog-confirm>
    <biometria
      tipoBiometria="verificacao"
      :modal="biometria"
      :userId="usuarioBiometria"
      :titulo="
        filtros.status == 'separado'
          ? 'Enviar Transferencia'
          : 'Receber transferencia'
      "
      @negativePrint="recebeBiometria"
      @resultadoVerificacao="receberResultadoBiometria"
    >
    </biometria>

    <div
      class="row col-12 items-center q-gutter-sm q-mt-lg"
      v-if="filtros.status != 'entregue'"
    >
      <div class="col-lg-2 col-md-3 col-xs-4">
        <div class="texto-titulo-input text-brand-5 text-weight-bold q-ml-sm">
          Usuário Indicado
        </div>
        <SelecaoSolicitante
          :resetar="resetar"
          @emitirFuncionario="receberUsuarioBiometria"
          :vendor-id="vendorIdAtual"
        />
      </div>

      <div class="q-mt-xs">
        <q-btn
          :disable="tipoAuth.length == 0 || usuarioBiometria == null"
          :label="
            filtros.status == 'separado'
              ? 'Enviar Transferencia'
              : 'Receber Transferencia'
          "
          icon="add"
          color="positive"
          class="q-mt-lg"
          no-caps
          @click="(confirmacao = true), salvarAssinatura++"
        />
      </div>
    </div>
  </q-page>
</template>

<script>
import { ref, watch, computed, onMounted } from "vue";
import { useStore } from "vuex";
import SelecaoSolicitante from "../components/SelecaoSolicitante.vue";
import { useRoute, useRouter } from "vue-router";
import Biometria from "../../biometria/views/Biometria.vue";
import Canvas from "../../requisicao/components/Canvas.vue";
import { useQuasar } from "quasar";
import DialogConfirm from "../components/DialogConfirm.vue";
import { watchDebounced } from "@vueuse/core";
import PageHeader from "../../../components/PageHeader.vue";

export default {
  components: {
    Biometria,
    SelecaoSolicitante,
    DialogConfirm,
    Canvas,
    PageHeader,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const quasar = useQuasar();
    //const router = useRouter()

    const columns = ref([
      {
        name: "voucherId",
        label: "Numero Requisição",
        field: "voucherId",
        align: "left",
        sortable: false,
      },
      {
        name: "reserva",
        label: "Numero Reserva",
        field: (row) => row?.detalhesProduto?.reserva,
        align: "left",
        sortable: false,
      },

      {
        name: "codigo",
        label: "Codigo",
        field: (row) => row?.detalhesProduto?.codigo,
        align: "left",
        sortable: false,
      },
      {
        name: "descricao",
        label: "Descrição",
        field: (row) => row?.detalhesProduto?.nome,
        align: "left",
        sortable: false,
      },
      {
        name: "deposito",
        label: "Deposito",
        field: (row) => row?.detalhesProduto?.deposito,
        align: "left",
        style: "width: 20px",
        sortable: false,
      },
      {
        name: "centro",
        label: "Centro",
        field: (row) => row?.detalhesProduto?.centro,
        align: "left",
        sortable: false,
      },
      {
        name: "lote",
        label: "Lote",
        field: (row) => row?.detalhesProduto?.lote,
        align: "left",
        sortable: false,
      },
      {
        name: "localizacao",
        label: "Localização",
        field: (row) => row?.detalhesProduto?.localizacao,
        align: "left",
        sortable: false,
      },
      {
        name: "preco",
        label: "Preço",
        field: "preco",
        align: "left",
        sortable: false,
      },
      {
        name: "saldo",
        label: "Estoque Origem",
        field: (row) => row?.detalhesProduto?.saldoEstoqueOrigem,
        align: "left",
        sortable: false,
      },
      {
        name: "quantidadeOriginal",
        label: "Quantidade Solicitada",
        field: "quantidadeOriginal",
        align: "left",
        sortable: false,
      },
      {
        name: "quantidadeAtendida",
        label: "Quantidade Separada",
        field: "quantidadeAtendida",
        align: "left",
        sortable: false,
      },
    ]);

    const filtros = ref({
      unidadeOrigem: null,
      unidadeDestino: null,
      dataCriacao: null,
      status: null,
      criador: null,
      solicitante: null,
      separador: null,
      transportador: null,
      unidade: null,
      envio: null,
      recebimento: null,
    });

    const resetar = ref(0);
    const usuarioBiometria = ref(null);
    const imagemBase64 = ref(null);
    const biometria = ref(false);
    const listaUsuariosSeparador = ref([]);
    const tipoAuth = ref([]);
    const listaUsuariosTransportador = ref([]);
    const numero = ref(null);
    const salvarAssinatura = ref(0);
    const pin = ref("");
    const time = ref(null);
    const solicitanteId = ref("");
    const unidadeOrigemId = ref(null);
    const unidadeDestinoId = ref(null);

    // Computed: envio filtra pela origem, recebimento filtra pelo destino
    const vendorIdAtual = computed(() =>
      filtros.value.status === "separado"
        ? unidadeOrigemId.value
        : unidadeDestinoId.value
    );

    const envio = ref({
      solicitante: null,
      separador: null,
      transportador: null,
    });

    const confirmacao = ref(false);
    const numeroPicking =
      route.params && route.params.id ? route.params.id : "";
    const idPicking = ref(null);

    const disable = ref(false);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 50,
      rowsNumber: 50,
    });
    let mobile = ref(false);
    const rows = ref([]);

    if (quasar.platform.is.mobile) {
      mobile.value = true;
    }

    const getData = async () => {
      store.dispatch("pdt/hiddenHeader", true);
      try {
        let response = await store.dispatch("pkg/getListagemPickings", {
          numero: numeroPicking,
        });

        if (
          store.state.autenticacao.cliente[0] == "cerradinho" ||
          store.state.autenticacao.cliente[0] == "staging-cerradinho"
        ) {
          columns.value = columns.value.filter((value) => {
            if (
              value.name != "deposito" &&
              value.name != "lote" &&
              value.name != "preco"
            ) {
              return value;
            }
          });
        }

        rows.value = response.data?.result?.dados?.[0].itens;
        filtros.value.status = response.data?.result?.dados?.[0].status;
        numero.value = response.data.result?.dados?.[0].numero;
        idPicking.value = response.data.result?.dados?.[0].pickingUuid;

        filtros.value.unidadeDestino =
          response.data.result?.dados?.[0].unidadeNomeDestino;
        filtros.value.unidadeOrigem =
          response.data.result?.dados?.[0].unidadeNomeOrigem;
        unidadeOrigemId.value =
          response.data.result?.dados?.[0].unidadeIdOrigem || null;
        unidadeDestinoId.value =
          response.data.result?.dados?.[0].unidadeIdDestino || null;
        filtros.value.criador =
          response.data.result?.dados?.[0].usuarioCriacao?.name;
        filtros.value.transportador =
          response.data.result?.dados?.[0].usuarioTransportador?.name;
        filtros.value.solicitante =
          response.data.result?.dados?.[0].usuarioSolicitante?.name;

        filtros.value.envio =
          response.data.result?.dados?.[0].usuarioEnvio?.name;

        filtros.value.recebimento =
          response.data.result?.dados?.[0].usuarioRecebimento?.name;

        solicitanteId.value =
          response.data.result?.dados?.[0].usuarioSolicitante?.id;
        filtros.value.separador =
          response.data.result?.dados?.[0].usuarioSeparador;
        filtros.value.dataCriacao =
          response.data.result?.dados?.[0]?.dataCriacao
            .split(" ")[0]
            .split("-")
            .reverse()
            .join("/") +
          " " +
          response.data.result?.dados?.[0]?.dataCriacao.split(" ")[1];

        disable.value = false;
      } catch (error) {
        quasar.notify({
          message: "Erro ao procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const listarUsers = async (value, type) => {
      try {
        const response = await store.dispatch("pkg/listarUsuarios", {
          per_page: 4,
          search: value,
          vendor_id: filtros.value.unidade.id,
        });

        switch (type) {
          case "transportador":
            listaUsuariosTransportador.value = response.data.results.data;
            break;
          case "separador":
            listaUsuariosSeparador.value = response.data.results.data;
            break;
        }
      } catch (error) {
        console.log(error);
      }
    };

    const imprimirPicking = async () => {
      router.push({ name: "pkg-imprimir", params: { id: idPicking.value } });
    };

    const imprimirPickingAgrupado = async () => {
      router.push({
        name: "pkg-imprimir-agrupado",
        params: { id: idPicking.value },
      });
    };

    const receberFuncionario = (value) => {
      filtros.value.solicitante = value;
    };

    const enviar = async (resultado) => {
      confirmacao.value = false;

      if (resultado && tipoAuth.value == "biometria") {
        biometria.value = !biometria.value;
      } else if (resultado) {
        if (filtros.value.status == "separado") {
          enviarPicking();
        } else if (filtros.value.status == "em transito") {
          receberPicking();
        }
      }
    };

    onMounted(() => {
      getData();
    });

    const editarQuantidade = async (row) => {
      console.log(row);
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        filtros.value.unidade = store.state.org.unidadeData;
      }
    );
    const handleRequest = async () => {
      // listarPicking( props.pagination.page, props.pagination.rowsPerPage);
    };

    const enviarPicking = async () => {
      if (
        (tipoAuth.value == "biometria" && imagemBase64.value == null) ||
        (tipoAuth.value == "assinatura" && imagemBase64.value == null)
      ) {
        quasar.notify({
          message: "Assine ou faça a biometria para enviar o picking.",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }

      try {
        if (tipoAuth.value == "web_pin" && pin.value != "") {
          const response = await store.dispatch("requisicao/checarPin", {
            pin: pin.value,
            user_id: usuarioBiometria.value,
          });

          if (response.data.result.pin_correto) {
            quasar.notify({
              message:
                "Senha Validada com Sucesso, a requisição será finalizada!",
              color: "positive",
              actions: [
                {
                  label: "fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
          } else {
            quasar.notify({
              message: "PIN digitado, não corresponde ao pin do usuário!",
              color: "negative",
              actions: [
                {
                  label: "fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
            return;
          }
        }
        await store.dispatch("pkg/enviarPicking", {
          numero: idPicking.value,
          auth_type: tipoAuth.value,
          auth_content:
            tipoAuth.value == "web_pin"
              ? pin.value
              : tipoAuth.value == "token"
              ? store.state.autenticacao.token
              : imagemBase64.value,
          usuario_id: usuarioBiometria.value,
        });

        await getData();
        resetar.value++;
        usuarioBiometria.value = null;
        quasar.notify({
          message: "Transferencia Picking enviada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        tipoAuth.value = [];
      } catch (error) {
        quasar.notify({
          message: "Erro ao enviar picking",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const receberPicking = async () => {
      if (
        (tipoAuth.value == "biometria" && imagemBase64.value == null) ||
        (tipoAuth.value == "assinatura" && imagemBase64.value == null)
      ) {
        quasar.notify({
          message: "Assine ou faça a biometria para enviar o picking.",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        if (tipoAuth.value == "web_pin" && pin.value != "") {
          const response = await store.dispatch("requisicao/checarPin", {
            pin: pin.value,
            user_id: usuarioBiometria.value,
          });

          if (response.data.result.pin_correto) {
            quasar.notify({
              message:
                "Senha Validada com Sucesso, a requisição será finalizada!",
              color: "positive",
              actions: [
                {
                  label: "fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
          } else {
            quasar.notify({
              message: "PIN digitado, não corresponde ao pin do usuário!",
              color: "negative",
              actions: [
                {
                  label: "fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
            return;
          }
        }
        await store.dispatch("pkg/receberPicking", {
          numero: idPicking.value,
          auth_type: tipoAuth.value,
          auth_content:
            tipoAuth.value == "web_pin"
              ? pin.value
              : tipoAuth.value == "token"
              ? store.state.autenticacao.token
              : imagemBase64.value,
          usuario_id: usuarioBiometria.value,
        });

        await getData();
        resetar.value++;
        usuarioBiometria.value = null;

        quasar.notify({
          message: "Transferencia Picking recebida com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        tipoAuth.value = [];
      } catch (error) {
        quasar.notify({
          message: "Erro ao procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const receberResultadoBiometria = (value) => {
      if (value && filtros.value.status == "separado") {
        enviarPicking();
      } else if (value && filtros.value.status == "em transito") {
        receberPicking();
      }
    };

    const receberUsuarioBiometria = (value) => {
      usuarioBiometria.value = value.id;
    };

    const recebeBiometria = async (value) => {
      imagemBase64.value = value;
    };

    const recebeAssinatura = async (value) => {
      imagemBase64.value = value;
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watchDebounced(
      [
        () => filtros.value.unidade,
        () => filtros.value.requisicao,
        () => filtros.value.reserva,
        () => filtros.value.deposito,
        () => filtros.value.centro,
        () => filtros.value.lote,
      ],
      () => {
        handleRequest();
      },
      { debounce: 400 }
    );

    return {
      filtros,
      pagination,
      disable,
      columns,
      handleRequest,
      editarQuantidade,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      confirmacao,
      enviar,
      enviarPicking,
      receberUsuarioBiometria,
      usuarioBiometria,
      numeroPicking,
      salvarAssinatura,
      numero,
      tipoAuth,
      imprimirPicking,
      imprimirPickingAgrupado,
      envio,
      pin,
      recebeAssinatura,
      listaUsuariosSeparador,
      filterTransportador(val, update, abort) {
        clearTimeout(time.value);
        if (val.length < 1) {
          abort();
          return;
        }

        time.value = setTimeout(() => {
          listarUsers(val, "transportador");
        }, 2000);

        setTimeout(() => {
          update();
        }, 2500);
      },
      filterSeparador(val, update, abort) {
        clearTimeout(time.value);
        if (val.length < 1) {
          abort();
          return;
        }

        time.value = setTimeout(() => {
          listarUsers(val, "separador");
        }, 2000);

        setTimeout(() => {
          update();
        }, 2500);
      },

      receberFuncionario,
      biometria,
      recebeBiometria,
      receberResultadoBiometria,
      listaUsuariosTransportador,
      mobile,
      rows,
      imagemBase64,
      solicitanteId,
      receberPicking,
      resetar,
      unidadeOrigemId,
      unidadeDestinoId,
      vendorIdAtual,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.texto-titulo {
  font-size: 20px;
}
.container-link-voltar {
  margin-right: 10px;
}
.icon-voltar {
  font-size: 25px;
}
.titulo-tabela {
  font-size: 18px;
}
.card {
  border: 1px solid #707070;
}
.text-grid-table {
  font-size: 19px;
}
@media (max-width: 1024px) {
  .texto-titulo-input {
    font-size: 15px;
  }
  .texto-titulo-radio {
    font-size: 18px;
  }
  .titulo-tabela {
    font-size: 20px;
    margin-bottom: 10px;
    margin-left: 0px;
  }
  .btn-grid {
    font-size: 19px;
  }
}
@media (max-width: 600px) {
  .container-link-voltar {
    margin: 5px 0px 0px 0px;
  }
  .icon-voltar {
    font-size: 20px;
    margin-right: 1px;
  }
  .texto-titulo {
    font-size: 17px;
  }
  .texto-titulo-input {
    font-size: 15px;
  }
  .titulo-tabela {
    font-size: 15px;
    margin-bottom: 10px;
    margin-left: 0px;
  }
  .texto-colunas {
    font-size: 10px;
  }
}
</style>
